export default function(response) {
  if (response.status === 403 || response.status === 409) {
    window.location.reload();
  }
  if (!response.ok) {
    throw Error(response.statusText);
  }
  return response;
}
